import React from 'react'
import { Navigate } from 'react-router-dom'
import { connect } from 'react-redux'
import withRouter from '../../services/util/withRouter'

const mapStateToProps = state => ({  
  user: state.user,
})

const PrivateRoute = ({ children, user, location }) => {  
  return user != null ? children : <Navigate to="/login" replace />
}

export default connect(mapStateToProps)(withRouter(PrivateRoute))
